/**
 * MVP2.4 T9.1 — 5 états de réussite (cf. docs/intelligence-layer-vision.md §6.8).
 *
 * Les 3 success outcomes sont **inférés automatiquement** côté client (temps
 * de réponse + hint utilisé). Le fail outcome demande un prompt UX 1-clic à
 * Léon (« Tu as compris pourquoi ? ») — c'est la seule action mentale
 * supplémentaire vs MVP1.
 *
 * Helpers partagés entre Opening Lab, Tactics Dojo et Endgame Forge — single
 * source of truth.
 */

export type SuccessOutcome = 'success_clean' | 'success_slow' | 'success_with_hint';
export type FailOutcome = 'fail_understood' | 'fail_not_understood';
export type Outcome = SuccessOutcome | FailOutcome;

/**
 * Seuil de réussite « rapide » par défaut. Au-delà, on bascule en
 * `success_slow` — utile pour distinguer mémoire éclair vs reconstruction
 * lente. 10s correspond à l'heuristique tactique courante chez Léon
 * (puzzles Lichess 1900-2300 médiane ~15s — donc <10s = mémoire pure).
 */
const FAST_SUCCESS_THRESHOLD_MS = 10_000;

export function classifySuccessOutcome(opts: {
  timeSpentMs: number;
  hintUsed?: boolean;
  fastThresholdMs?: number;
}): SuccessOutcome {
  if (opts.hintUsed === true) return 'success_with_hint';
  const threshold = opts.fastThresholdMs ?? FAST_SUCCESS_THRESHOLD_MS;
  return opts.timeSpentMs <= threshold ? 'success_clean' : 'success_slow';
}
